// Labels shared by the CRM training pages.

export const ACCREDITATION_STATUS = [
  { value: 'none', label: 'Not submitted', color: '#64748B' },
  { value: 'submitted', label: 'Submitted', color: '#268EBB' },
  { value: 'in-principle', label: 'In principle', color: '#85276A' },
  { value: 'accredited', label: 'Accredited', color: '#00964C' },
  { value: 'lapsed', label: 'Lapsed', color: '#B45309' },
]

export const accreditationMeta = (status) =>
  ACCREDITATION_STATUS.find((entry) => entry.value === status) ?? ACCREDITATION_STATUS[0]

export const VERSION_STATUS_COLOR = {
  published: '#00964C',
  draft: '#64748B',
  'in-review': '#268EBB',
  retired: '#B45309',
}

// Free-text questions of the CPD UK feedback form, in form order.
export const COMMENT_QUESTIONS = [
  { field: 'additionalResources', label: 'Additional resources that would have helped' },
  { field: 'topicsForMoreDepth', label: 'Topics that should be covered in more depth' },
  { field: 'improvements', label: 'Suggested improvements' },
  { field: 'postCompletionEngagement', label: 'Engagement after completing the course' },
  { field: 'mostFrustrating', label: 'Most frustrating part of the course' },
]
